import 'src/styles/ui/selectable-card.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Radio from 'src/components/ui/radio';

/**
 * A selectable radio-card — a bordered card with the shared Radio control.
 * Selecting reveals the card's nested content full-width below the header row
 * (never squeezed into the title column). Generic: usable by any feature that
 * offers a single-choice list of rich options.
 */
const SelectableCard = ({ id, name, icon, title, desc, active, danger, onSelect, children }) => (
  <div
    className={classNames('selectable-card', { 'selectable-card--selected': active })}
    role='button'
    tabIndex={0}
    onClick={() => onSelect(id)}
    onKeyDown={event => {
      if (event.key === 'Enter' || event.key === ' ') onSelect(id);
    }}
  >
    <div className='selectable-card__head'>
      {icon && (
        <span
          className={classNames('selectable-card__icon', {
            'selectable-card__icon--danger': danger,
          })}
        >
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      <div className='selectable-card__body'>
        <div
          className={classNames('selectable-card__title', {
            'selectable-card__title--danger': danger,
          })}
        >
          {title}
        </div>
        {desc && <div className='selectable-card__desc'>{desc}</div>}
      </div>
      <span className='selectable-card__radio'>
        <Radio
          id={`selectable-card-${id}`}
          name={name}
          checked={active}
          onChange={() => onSelect(id)}
        />
      </span>
    </div>
    {active && children && (
      <div className='selectable-card__content' onClick={event => event.stopPropagation()}>
        {children}
      </div>
    )}
  </div>
);

SelectableCard.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.object,
  title: PropTypes.node.isRequired,
  desc: PropTypes.node,
  active: PropTypes.bool.isRequired,
  danger: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.node,
};

SelectableCard.defaultProps = { icon: null, desc: null, danger: false, children: null };

export default SelectableCard;
